import classNames from "classnames";
import React from "react";

export interface InformationRowsProps {
  items: Array<[React.ReactNode, React.ReactNode]>;
  shouldTopAlign?: true;
  style?: React.CSSProperties;
}

export function InformationRow(props: {
  label: React.ReactNode;
  children?: React.ReactNode;
  shouldTopAlign?: true;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className={classNames("columns is-gapless", {
        "is-vcentered": props.shouldTopAlign !== true,
      })}
      style={{ marginBottom: "0.5em", ...props.style }}
    >
      <div className="column">{props.label}:</div>
      <div className="column has-text-right-tablet">{props.children}</div>
    </div>
  );
}

export function InformationRows(props: InformationRowsProps) {
  return (
    <>
      {props.items.map(([label, content], i) => (
        <InformationRow
          key={i}
          label={label}
          shouldTopAlign={props.shouldTopAlign}
          style={props.style}
        >
          {content}
        </InformationRow>
      ))}
    </>
  );
}
